/**
 * Created by asiulik on 15.05.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './mapStyles', 'async'], function ($, _, EventEmitter, mapStyles) {

    var googleMapsApiKey = 'AIzaSyA6QczZcmOd3NGdLpbntXRej-bhpgWbFHQ';

    function Map(mapSelector, config) {

        if (!mapSelector) {
            throw new Error('map selector required to create map instance');
        }

        this.map = mapSelector;

        this.defaultConfig = {
            center: {lat: -34.397, lng: 150.644},
            zoom: 8,
            scrollwheel: false,
            navigationControl: false,
            mapTypeControl: false,
            styles: mapStyles
        };

        this.config = _.assign(this.defaultConfig, config);
    }

    Map.prototype = _.clone(EventEmitter.prototype);

    Map.prototype.init = function () {

        var _this = this;

        this.$mapPreloader = this.config.mapPreloaderSelector; //@todo change name selector -> $elem

        this.toggleMapPreloader(true);

        if (!window.google) {
            $.getScript('//maps.googleapis.com/maps/api/js?key=' + googleMapsApiKey, function () {
                _this.initialize();
            });
        } else {
            _this.initialize();
        }
    };

    Map.prototype.toggleMapPreloader = function (showPreloader) {

        if (!this.$mapPreloader.length) return;
        showPreloader ? this.$mapPreloader.show() : this.$mapPreloader.hide();

    };

    Map.prototype.initialize = function () {

        var _this = this;

        this.createMap();
        this.emit('map.inited');

        google.maps.event.addListenerOnce(this.getMap(), 'idle', function(){
            _this.toggleMapPreloader();
        });

    };

    Map.prototype.createMap = function () {
        this.mapInstace = new google.maps.Map(this.map, this.config);
    };

    Map.prototype.getMap = function () {
        return this.mapInstace;
    };

    return Map;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/map/map.js